import { useEffect } from 'react'

const SITE_NAME = 'D A Y 2 D A Y'

// Client-side routing does not change document.title on its own. Leaving it
// static means every route has the same name in a browser tab, in history, in
// a bookmark, and — the one that matters — in a screen reader's announcement
// after navigation.
export function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title === SITE_NAME ? SITE_NAME : `${title} · ${SITE_NAME}`
  }, [title])
}
